import React, { Fragment } from "react";

export default function MaybeFragment({
  as: Component = "div",
  children,
  ...props
}) {
  if (Object.values(props).some((value) => value != null)) {
    return <Component {...props}>{children}</Component>;
  }
  return <Fragment>{children}</Fragment>;
}
